import React from 'react';

import DateFnsUtils from '@date-io/date-fns';

import { makeStyles }  from '@material-ui/core/styles';
import Button          from '@material-ui/core/Button';
import Dialog          from '@material-ui/core/Dialog';
import DialogActions   from '@material-ui/core/DialogActions';
import DialogContent   from '@material-ui/core/DialogContent';
import MenuItem        from '@material-ui/core/MenuItem';
import Table           from '@material-ui/core/Table';
import TableBody       from '@material-ui/core/TableBody';
import TableCell       from '@material-ui/core/TableCell';
import TableContainer  from '@material-ui/core/TableContainer';
import TableRow        from '@material-ui/core/TableRow';
import TextField       from '@material-ui/core/TextField';
import Typography      from '@material-ui/core/Typography';

import { KeyboardDateTimePicker }  from '@material-ui/pickers';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import { create, date, selectable } from '../util';

const style = {
  newPayment: makeStyles((theme) => ({
    amount: {
      display: 'flex',
      gap: theme.spacing(2),
    },
    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(4),
    },
    dialogTitle: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
    },
  })),
};

export default function NewPayment(props) {
  const classes = style.newPayment();

  const { ticketDetail, ticketOptions } = props.context.getStates();

  return (
    <Dialog fullWidth open={props.newPayment.rowid > -2}>
      <DialogContent className={classes.dialogContent}>
        <div className={classes.dialogTitle}>
          <Typography variant="h6">
            {props.newPayment.rowid === -1 ? '새 결제 내역' : '결제 내역 수정'}
          </Typography>

          {props.newPayment.rowid === -1 ? (
            <Button color="primary" onClick={(event) => { props.insertPayment(); }}>
              {'등록'}
            </Button>
          ): (
            <Button color="secondary"
              disabled={props.newPayment.issued.length > 0}
              onClick={(event) => { props.deletePayment(); }}
            >{'삭제'}</Button>
          )}
        </div>

        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDateTimePicker format="yyyy/MM/dd hh:mm a"
            label={'결제일'}
            onChange={(datetime) => {
              props.setNewPayment({...props.newPayment, date: datetime.getTime()});
            }}
            value={new Date(props.newPayment.date)}
          />
        </MuiPickersUtilsProvider>

        <div className={classes.amount}>
          <TextField label={'결제 금액'}
            onChange={(event) => {
              props.setNewPayment({...props.newPayment, amount: event.target.value});
            }}
            style={{flexGrow: 2}}
            value={props.newPayment.amount}
          />

          <TextField select label={'단위'}
            onChange={(event) => {
              props.setNewPayment({...props.newPayment, currency: event.target.value});
            }}
            value={props.newPayment.currency}
          >
            {selectable.payCurrencies.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          <TextField select label={'결제 방법'}
            onChange={(event) => {
              props.setNewPayment({...props.newPayment, method: event.target.value});
            }}
            style={{flexGrow: 1}}
            value={props.newPayment.method}
          >
            {selectable.payMethods.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

        </div>

        <TextField multiline rows={4} label={'비고'}
          onChange={(event) => {
            props.setNewPayment({...props.newPayment, note: event.target.value});
          }}
          value={props.newPayment.note}
        />

        {props.newPayment.rowid > -1 && (<>
          <div className={classes.dialogTitle}>
            <Typography variant="h6">{'티켓'}</Typography>

            <Button color="primary"
              onClick={(event) => { props.setNewTickets(
                [ticketOptions[0].value, 0]
              ); }}
            >{'추가'}</Button>
          </div>

          <TableContainer>
            <Table>
              <TableBody>
                {Object.keys(ticketDetail).length > 0 && props.newPayment.issued.map(ticket => (
                  <TableRow key={ticket['issued_rowid']}>
                    <TableCell component="th" scope="row" style={{whiteSpace: 'nowrap'}}>
                      {ticket['issued_rowid']}
                    </TableCell>
                    <TableCell component="th" scope="row" style={{whiteSpace: 'nowrap'}}>
                      {ticketDetail[ticket['ticket_rowid']].name}<br/>
                      <span style={{color: 'lightgray'}}>{
                        date.withoutTime(ticketDetail[ticket['ticket_rowid']].activeFrom) + ' ~ ' +
                        date.withoutTime(ticketDetail[ticket['ticket_rowid']].activeUntil)
                      }</span>
                    </TableCell>
                    <TableCell align="right" style={{whiteSpace: 'nowrap'}}>
                      <Button color={'secondary'}
                        disabled={ticket['used_at'] ? true : false}
                        onClick={(event) => { props.deleteTickets(ticket['issued_rowid']); }}
                        style={{padding: 0}}
                      >{'삭제'}</Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>)}
      </DialogContent>

      <DialogActions>
        <Button onClick={(event) => {
          props.setNewPayment(create.payment());
          props.setRevision((oldRevision) => (oldRevision + 1));
        }}>
          {'취소'}
        </Button>
        <Button color="primary" onClick={(event) => {
          if (props.newPayment.rowid === -1) {
            props.insertPayment(-2);
          } else {
            props.updatePayment();
          }
        }}>
          {'확인'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
